import React, { useEffect, useState } from 'react';

function LockdownScreen({ message, since, onLogout }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const formatTime = (d) => {
    if (!d) return null;
    return new Date(d).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  const getElapsed = () => {
    if (!since) return null;
    const diff = Math.max(0, Math.floor((now - new Date(since)) / 1000));
    const h = Math.floor(diff / 3600);
    const m = Math.floor((diff % 3600) / 60);
    const s = diff % 60;
    const hs = String(h).padStart(2, '0');
    const ms = String(m).padStart(2, '0');
    const ss = String(s).padStart(2, '0');
    return `${hs}:${ms}:${ss}`;
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 99999,
      background: '#0a0a0f',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Geist', 'Inter', system-ui, sans-serif"
    }}>
      <div style={{
        position: 'absolute', inset: 0,
        background: 'radial-gradient(ellipse at center, rgba(239,68,68,0.06) 0%, transparent 65%)',
        pointerEvents: 'none'
      }} />

      <div style={{ textAlign: 'center', maxWidth: 440, padding: '0 24px', position: 'relative' }}>
        {/* Icon */}
        <div style={{
          width: 56, height: 56, borderRadius: 12,
          background: 'rgba(239,68,68,0.08)',
          border: '1px solid rgba(239,68,68,0.25)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 24px',
          boxShadow: '0 0 24px rgba(239,68,68,0.12)'
        }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
        </div>

        <div style={{
          display: 'inline-block',
          background: 'rgba(239,68,68,0.08)',
          border: '1px solid rgba(239,68,68,0.2)',
          borderRadius: 4, padding: '2px 10px',
          color: '#ef4444', fontSize: 11, fontWeight: 600,
          letterSpacing: '0.1em', textTransform: 'uppercase',
          marginBottom: 16
        }}>SYSTEM LOCKDOWN</div>

        <h1 style={{ color: '#f0f2f5', fontSize: 22, fontWeight: 700, margin: '0 0 10px', letterSpacing: '-0.02em' }}>
          System gesperrt
        </h1>
        <p style={{ color: '#6b7585', fontSize: 14, lineHeight: 1.65, margin: '0 0 28px' }}>
          {message || 'Der Zugriff auf diese Plattform wurde vom Administrator gesperrt.'}
        </p>

        <div style={{
          background: 'rgba(22,27,39,0.7)',
          border: '1px solid rgba(255,255,255,0.06)',
          borderRadius: 8, padding: '16px 20px',
          display: 'flex', flexDirection: 'column', gap: 10
        }}>
          {since && (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#404857', fontSize: 13 }}>Gesperrt seit</span>
              <span style={{ color: '#7a8494', fontSize: 13, fontFamily: "'JetBrains Mono', monospace" }}>{formatTime(since)}</span>
            </div>
          )}
          {since && (
            <>
              <div style={{ height: 1, background: 'rgba(255,255,255,0.04)' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: '#404857', fontSize: 13 }}>Läuft seit</span>
                <span style={{ color: '#ef4444', fontSize: 14, fontFamily: "'JetBrains Mono', monospace", fontWeight: 500 }}>{getElapsed()}</span>
              </div>
            </>
          )}
        </div>

        <p style={{ color: '#2e3440', fontSize: 12, marginTop: 24 }}>
          AquaV Cloud — aquavservices@gmail.com
        </p>
      </div>

      <button
        onClick={onLogout}
        style={{
          position: 'fixed', bottom: 20, right: 20,
          background: 'rgba(255,255,255,0.06)',
          border: '1px solid rgba(255,255,255,0.14)',
          borderRadius: 6,
          color: '#8b95a8',
          fontSize: 12,
          padding: '6px 12px',
          cursor: 'pointer',
          fontFamily: "'Geist', 'Inter', system-ui, sans-serif",
          display: 'flex', alignItems: 'center', gap: 6,
          letterSpacing: '0.01em',
          transition: 'color 0.2s, border-color 0.2s, background 0.2s'
        }}
        onMouseEnter={e => { e.currentTarget.style.color = '#f0f2f5'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.28)'; e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }}
        onMouseLeave={e => { e.currentTarget.style.color = '#8b95a8'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.14)'; e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; }}
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
          <polyline points="16 17 21 12 16 7"/>
          <line x1="21" y1="12" x2="9" y2="12"/>
        </svg>
        Abmelden
      </button>
    </div>
  );
}

export default LockdownScreen;
